// AddressesModal.jsx
import "./MainContentModal.scss";

function MainContentModal({ isOpen, onClose, children }) {
  if (!isOpen) return null; // only render when open

  return (
    <div className="mcm-modal-container" onClick={onClose}>
      <div className="mcm-modal-content" onClick={(e) => e.stopPropagation()}>
        {/*
        <button className="mcm-modal-close" onClick={onClose}>
          ×
        </button>
        */}
        {children}
      </div>
    </div>
  );
}

export default MainContentModal;
